import { SVGIcon } from '@superops/super-icons';
import { TextStyle } from '@superops/ui-design-system';
import { isEmpty } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';

function TypingText({ userActiveConversation, isWeb }) {
  return (
    <div className="flex position-absolute b25 ">
      <div className="flex actr mlr5">
        <SVGIcon name="Pencil" />
      </div>
      <TextStyle variation="subdued">
        {isEmpty(userActiveConversation) ? (
          <FormattedMessage id="common.labal.typing" />
        ) : (
          <FormattedMessage
            id="msp.chat.user.action.typing"
            values={{
              name: isWeb
                ? userActiveConversation?.recipients?.receiver?.[0]?.name
                : userActiveConversation?.recipients?.initiator?.user?.name
            }}
          />
        )}
      </TextStyle>
    </div>
  );
}

export default TypingText;
